import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import compose from 'recompose/compose';
import { makeBgImage, noneStyle } from '../../../../../helpers/common';
import { propArrayShape, propBool, propFunc, } from '../../../../../helpers/custom-prop-types';
import IsProcessLoadingHoc from '../../../../Layout/Loading/IsProcessLoadingHoc';
import MediaQuerySmallDeviceHoc from '../../../../Layout/MediaQuery/MediaQuerySmallDeviceHoc';
import CustomSlider from '../../../../Ui/Slider';
const config = {
    arrows: true,
    infinite: true,
    responsive: [
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
    slidesToShow: 5,
    speed: 300,
};
const RecommendationSliderTemplateItems = (props) => {
    const { isSmall, items, onClick } = props;
    const fillCount = isSmall ? 1 : 5;
    const setFillCount = Math.max(fillCount - items.length, 0);
    const fillItems = [...Array(setFillCount)].map((_, index) => index);
    return (_jsxs(CustomSlider, Object.assign({ className: 'solution-slider is-recommendation', config: config, dataAttributes: {} }, { children: [items.map((item) => {
                const { id, thumbnail, title } = item;
                return (_jsx("li", Object.assign({ className: 'slide-item' }, { children: _jsxs(Link, Object.assign({ className: 'su-is-full', onClick: (e) => {
                            if (onClick) {
                                onClick(e);
                            }
                        }, to: `/solutions/${id}` }, { children: [_jsx("div", { className: 'pickup-image', style: makeBgImage(thumbnail) }), _jsx("div", { children: _jsx("p", { children: title }) })] })) }), id));
            }), fillItems.map((value) => (_jsx("li", { style: noneStyle }, value)))] })));
};
RecommendationSliderTemplateItems.propTypes = {
    isSmall: propBool().isRequired,
    items: propArrayShape().isRequired,
    onClick: propFunc(),
};
RecommendationSliderTemplateItems.defaultProps = {
    onClick: null,
};
const enhance = compose(IsProcessLoadingHoc({ backgroundIsTransparent: true }), MediaQuerySmallDeviceHoc);
export default enhance(RecommendationSliderTemplateItems);
